const PLACEHOLDER_TICKET_LINKS = new Set(['', 'null', 'undefined']);

const buildExternalTicketUrl = (ticketLink, affiliate) => {
  const rawLink = typeof ticketLink === 'string' ? ticketLink.trim() : '';

  if (PLACEHOLDER_TICKET_LINKS.has(rawLink.toLowerCase())) {
    return null;
  }

  try {
    const url = new URL(rawLink);
    if (!['http:', 'https:'].includes(url.protocol)) {
      return null;
    }

    if (affiliate) {
      url.searchParams.set('aff', affiliate);
    }

    return url.toString();
  } catch {
    return null;
  }
};

export default buildExternalTicketUrl;
